import { Box, SimpleGrid } from "@chakra-ui/react";
import CardBox from "./CardBox";
import { useDispatch, useSelector } from "react-redux";
import { loadInsightsRequest } from "../../store/insightsSlice";
import { useEffect, useState } from "react";
import ProductCategories from "../../pages/product/ProductCategories";
import RegistrationMethods from "../../pages/product/RegistrationMethods";
import ComplaintCategories from "../../pages/complaint/ComplaintCategories";

export const Overview = ({ path, source }) => {

  const [startTime] = useState(Date.now() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
  const [endTime] = useState(Date.now());

  const overviewData = useSelector((state) => state.insights[path] || {
    cards: [],
    graphs: [],
    loading: false,
    error: null,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadInsightsRequest({
      key: path,
      startTime,
      endTime,
    }));
  }, [startTime, endTime]);

  return (
    <Box>
      <SimpleGrid
        columns={{ base: 1, sm: 2, md: 3, lg: 4 }}
        spacing={{ base: 4, md: 6 }}
      >
        {overviewData?.cards?.map((stat, index) => (
          <CardBox
            key={index}
            heading={stat.title}
            body={stat.value.toLocaleString()}
            footer={stat.subtitle}
            color={stat.color}
            source={source}
          />
        ))}
      </SimpleGrid>

      {overviewData?.graphs?.DailyComplaintsTrend &&
        <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} gap={5} >
          <ComplaintCategories complaintCategoriesData={overviewData?.graphs.DailyComplaintsTrend} />
        </SimpleGrid>
      }

      {overviewData?.graphs?.ProductCategories && overviewData?.graphs?.RegistrationMethods &&
        <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} gap={5} >
          <ProductCategories productCategoriesData={overviewData.graphs.ProductCategories} />
          <RegistrationMethods registrationMethods={overviewData.graphs.RegistrationMethods} />
        </SimpleGrid>
      }
    </Box>
  );
};
